export default {
  props: {
    show: {
      type: Boolean,
      default: false
    }
  },
  watch: {
    show: {
      immediate: true,
      handler: function (val, oldVal) {
        if (val) {
          this.visible = false
          this.$nextTick(() => {
            this.visible = true
          })
        }
      }
    }
  },
  data() {
    return {
      visible: false
    }
  },
  methods: {
    beforeCloseDialog(done) {
      this.$emit('beforeClose')
      done()
    },
    changeShow(val) {
      this.visible = val
      this.$emit('update:show', val);
    },
    closedDialog() {
      this.visible = false
      this.$emit('update:show', null);
    },
    doClose() {
      this.changeShow(false)
    }
  }
}
